import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';

interface ILoadingButtonProps extends ButtonProps {
    loading: boolean;
    disabled: boolean;
    label: string;
}

export const LoadingButton: React.FC<ILoadingButtonProps> = ({ loading, disabled, label, type, color, size, onClick = () => {} }) => (
    <Button
        type={type}
        variant="contained"
        color={color}
        size={size}
        fullWidth
        disabled={disabled}
        onClick={onClick}
        disableElevation
        startIcon={loading ? <CircularProgress size={22} /> : <LoginIcon />}
    >
        {loading ? 'Entrando...' : label}
    </Button>
);
